import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useHead } from '@unhead/vue'
import { useRoute, useRouter } from 'vue-router'
import NavLinkLanding from '@grantstreet/govhub-vue/src/views/NavLinkLanding.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  emits: ['redirect-click'],
  setup(__props) {


useHead({
  title: '',
})

const store = useStore()
const route = useRoute()
const router = useRouter()
const clientCover = computed(() => store.getters['PayHub/clientCover'])
const navLinks = computed(() => store.getters['PayHub/navLinks'](route, router))
const shouldAllowRedirect = computed(() => store.getters['PayHub/shouldAllowRedirect'])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavLinkLanding, {
    title: _ctx.$t('home.title'),
    "cover-src": clientCover.value,
    "nav-links": navLinks.value,
    "should-redirect": shouldAllowRedirect.value,
    onRedirectClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('redirect-click', $event)))
  }, null, 8, ["title", "cover-src", "nav-links", "should-redirect"]))
}
}

})